import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

function EditItem({ item, theme, onSave, onCancel }) {
    const { t } = useLanguage();
    const [editedItem, setEditedItem] = useState(item);

    // Helper to get options from item.option_group
    const getOptions = (item) => {
        if (!item.option_group || !item.option_group.options) return [];
        return item.option_group.options;
    };

    // Handle option selection
    const handleOptionChange = (option) => {
        setEditedItem(prev => ({
            ...prev,
            selectedOptions: { option },
            adjustedPrice: prev.price + (option.price_adjust || 0)
        }));
    };

    const options = getOptions(item);
    const selectedOptionId = editedItem.selectedOptions?.option?.id;

    return (
        <div style={{
            background: theme?.colors?.background,
            color: theme?.colors?.text,
            borderRadius: theme?.borderRadius || 8,
            boxShadow: theme?.boxShadow,
            padding: '1rem',
            minWidth: 320
        }}>
            <h3 style={{ color: theme?.colors?.primary }}>{t('editItem')}</h3>
            <div style={{ marginBottom: '1rem' }}>
                <strong>{item.name}</strong>
                <span style={{ color: theme?.colors?.secondary, marginLeft: 8 }}>
                    ${editedItem.adjustedPrice !== undefined ? (Number(editedItem.adjustedPrice) || 0).toFixed(2) : (Number(item.price) || 0).toFixed(2)}
                </span>
            </div>
            {/* Option selection UI */}
            {options.length > 0 && (
                <div style={{ marginBottom: '1rem' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{t('options')}:</div>
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                        {options.map(option => (
                            <button
                                key={option.id}
                                style={{
                                    padding: '0.375rem 0.75rem',
                                    background: selectedOptionId === option.id ? theme?.colors?.primary : theme?.colors?.surface,
                                    color: selectedOptionId === option.id ? theme?.colors?.surface : theme?.colors?.text,
                                    border: `1px solid ${theme?.colors?.primary}`,
                                    borderRadius: theme?.borderRadius || 4,
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    fontWeight: selectedOptionId === option.id ? 'bold' : 'normal',
                                    boxShadow: selectedOptionId === option.id ? theme?.boxShadow : 'none',
                                    transition: 'all 0.2s',
                                }}
                                onClick={() => handleOptionChange(option)}
                            >
                                {option.name}<br />
                                <span style={{ fontSize: '0.8rem' }}>
                                    ${((Number(item.price) || 0) + (Number(option.price_adjust) || 0)).toFixed(2)}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
            {/* Note field */}
            <div style={{ marginBottom: '1rem' }}>
                <label style={{ fontWeight: 'bold' }}>{t('note')}:</label>
                <textarea
                    value={editedItem.note || ''}
                    onChange={e => setEditedItem(prev => ({ ...prev, note: e.target.value }))}
                    style={{ width: '100%', minHeight: 40, borderRadius: theme?.borderRadius || 6, border: '1px solid #ccc', marginTop: 4 }}
                />
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                    style={{
                        background: theme?.colors?.primary,
                        color: theme?.colors?.surface,
                        border: 'none',
                        borderRadius: theme?.borderRadius || 8,
                        padding: '0.5rem 1.5rem',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        boxShadow: theme?.boxShadow,
                    }}
                    onClick={() => onSave(editedItem)}
                >
                    {t('save')}
                </button>
                <button
                    style={{
                        background: theme?.colors?.secondary,
                        color: theme?.colors?.surface,
                        border: 'none',
                        borderRadius: theme?.borderRadius || 8,
                        padding: '0.5rem 1.5rem',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        boxShadow: theme?.boxShadow,
                    }}
                    onClick={onCancel}
                >
                    {t('cancel')}
                </button>
            </div>
        </div>
    );
}

export default EditItem;
